import cls from "classnames";
import { useEffect, useState } from "react";
import { ButtonPrimary } from "@qoohoo/common/components/library/Button";

function GetOtpBtn(props) {
  const {
    isLoading,
    phoneNumber,
    selectedCountryCode,
    title,
    color,
    onClick,
    disabled,
  } = props;
  const [isActive, setIsActive] = useState(false);

  const isDisabled = disabled || !isActive || isLoading;

  function handleStateBasedOnCountry() {
    const isCountryCodeOfIndia = selectedCountryCode === "91";

    if (isCountryCodeOfIndia) {
      if (phoneNumber.length === 10) {
        setIsActive(true);
        return;
      }
    } else {
      if (phoneNumber.length > 4) {
        setIsActive(true);
        return;
      }
    }

    setIsActive(false);
  }

  useEffect(() => {
    handleStateBasedOnCountry();
  }, [phoneNumber, selectedCountryCode]);

  return (
    <ButtonPrimary
      form="phone-input-form"
      className="flex-1 leading-5 max-w-[320px] sm:max-w-[280px] text-base border"
      isLoading={isLoading}
      disabled={isDisabled}
      onClick={onClick}
      loaderColor={color.label}
      style={{
        color: color.label,
        backgroundColor: color.bg,
        borderColor: color.border,
      }}
      doOpacityForDisabled
    >
      {title}
    </ButtonPrimary>
  );
}

GetOtpBtn.prototype.color = {
  SMS: {
    label: "#FFFFFF",
    bg: "#384AF1",
    border: "#00000000",
  },
  WHATSAPP: {
    label: "#384AF1",
    bg: "#EDF3FE",
    border: "#E2E4FC",
  },
};

export default GetOtpBtn;
